define([
    'Magento_Customer/js/customer-data',
    'Lfi_Theme/js/storage'
], function (customerData, lfiStorage) {
    'use strict';

    return {
        keyFirstname: 'customer-firstname',
        keyEmail: 'customer-email',

        /**
         * A guest who has never logged in will not have any data saved in localstorage
         * Is there a better way to do this - probably
         * @returns {Boolean} status
         */
        hasCustomerAccount: function () {
            return typeof lfiStorage.get(this.keyFirstname) !== 'undefined';
        },

        /**
         * Magento_Customer/js/model/customer#isLoggedIn does not seem reliable outside of checkout context
         * Instead check customer data which is stored / cleared from localstorage during login / logout
         * @returns {Boolean} status
         */
        isLoggedIn: function () {
            const customerDataObj = customerData.get('customer')();
            return customerDataObj.hasOwnProperty('fullname') && customerDataObj.fullname.length > 0;
        },

        /**
         * @param {string} value to save
         * @returns {exports} self
         */
        setPersistentCustomerFirstname: function (value) {
            lfiStorage.set(this.keyFirstname, value);
            return this;
        },

        /**
         * @returns {string} value
         */
        getPersistentCustomerFirstname: function () {
            return this.hasCustomerAccount() ? lfiStorage.get(this.keyFirstname) : '';
        },

        /**
         * @param {string} value to save
         * @returns {exports} self
         */
        setPersistentCustomerEmail: function (value) {
            lfiStorage.set(this.keyEmail, value);
            return this;
        },

        /**
         * @returns {string} value
         */
        getPersistentCustomerEmail: function () {
            return this.hasCustomerAccount() ? lfiStorage.get(this.keyEmail) : '';
        }
    };
});
